// 引入一堆兼容
import 'url-search-params-polyfill'
import 'babel-polyfill'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from '@/App'
import router from '@/router'
import axios from '@/core/auth'
import iviewFixer from '@/core/mixins/iview'
import store from '@/store'
import VeeValidate, {
  Validator
} from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN'
import localForage from 'localforage'
import VueSweetalert2 from 'vue-sweetalert2'
import iView from 'iview'
import * as directives from './directives'
// iView 3.x
Vue.use(iView)

Vue.use(VeeValidate, {
  events: 'input|change',
  fieldsBagName: 'formFields'
})
Validator.localize('zh', zh)

Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.mixin(iviewFixer)

localForage.config({
  name: 'app'
})

Vue.prototype.$axios = axios
Vue.prototype.$storage = localForage

Object.keys(directives).forEach(k => Vue.directive(k, directives[k]))
/* eslint-disable no-new */
window.vue = new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js